import ApiService from "@/services/api.service";

const MatchService = {
    update(group: string, match: string, data: object) {
        return ApiService.put(`/group/${group}/matches/${match}`, data);
    },
    get(match: string) {
        return ApiService.get(`/matches/${match}`);
    },
    getGroupPredictions(group: string, match: string) {
        return ApiService.get(`/group/${group}/matches/${match}/predictions`);
    },
    getReusablePredictions(matchIds: string) {
        return ApiService.get(
            `/predictions?filter[soccer_match_id]=${matchIds}`,
        );
    },
    getTeamStatistics(matchId: string) {
        return ApiService.get(`/matches/${matchId}/statistics`);
    },
};
export default MatchService;
